'use strict';
import { __values } from "tslib";
// This controller used on both states:
// 'reviewOrder' (/cart/checkout/review-order)
// and
// 'placedOrder' (/cart/checkout/thankyou)
import angular from 'angular';
var OrderSummaryListController = /** @class */ (function () {
    /* @ngInject*/
    function OrderSummaryListController(Auth, $state, $scope, $rootScope, $mdDialog, CartService, SettingsService, Util, $window, $q, CSAService, ProductService, ItemWarningsService, CommonDataService, googleAnalytic, $compile, OrderSummaryEvents) {
        var _this = this;
        this.showAlert = true;
        this.processingOrder = false;
        this.cvvCode = '';
        this.closeAlertMessage = function () {
            _this.showAlert = false;
        };
        this.errors = {
            havePageErrors: false,
            pageErrors: '',
            pageErrorType: ''
        };
        this.orderHoldCodes = null;
        this.tableColSpan = 5; // number of columns determined by practitioner vs. patient account
        this.Auth = Auth;
        this.$state = $state;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$compile = $compile;
        this.CartService = CartService;
        this.SettingsService = SettingsService;
        this.ProductService = ProductService;
        this.itemWarningsService = ItemWarningsService;
        this.Util = Util;
        this.$window = $window;
        this.$mdDialog = $mdDialog;
        this.$q = $q;
        this.uiRouterState = $state.current.name;
        this.CSAService = CSAService;
        this.commonDataService = CommonDataService;
        this.GoogleAnalyticsService = googleAnalytic;
        this.orderSummaryEvents = OrderSummaryEvents;
        this.hideCVV = false;
        this.cvvPattern = '^[0-9]{3}$';
        this.cardType = this.CartService.ccType ? this.CartService.ccType : 0;
    }
    OrderSummaryListController.prototype.$onInit = function () {
        var e_1, _a;
        var _this = this;
        var self = this;
        this.hideCVV = this.CartService.ifHideCVV();
        this.CartService.hideCVV(false);
        this.$scope.setForm = function (form) {
            _this.$scope.cvvForm = form;
        };
        this.getOrderResultForThankyouPage();
        // TODO: update item number and price in cart
        this.CartService.getCartSummary();
        this.cvvAlreadySet = this.CartService.getCVV();
        // Check User is Logged in or not
        this.Auth.isLoggedIn(function (loggedInUser) {
            if (loggedInUser) {
                self.loggedInUser = loggedInUser;
                if (self.loggedInUser.isImpersonated) {
                    _this.getOrderHoldCodes();
                }
                self.tableColSpan = self.loggedInUser.accountType === 'Practitioner' ? 5 : 4;
            }
            if (loggedInUser == null) {
                _this.$window.location = '/auth/ares';
            }
        });
        this.hideCVV = this.CartService.ifHideCVV();
        self.customerPoNumber = undefined;
        if (this.CartService.cartData && this.CartService.cartData.aresLineItems) {
            if (this.uiRouterState === 'reviewOrder') {
                this.GoogleAnalyticsService.sendEvent('dc', 'review order page', '', 1);
            }
            else if (this.uiRouterState === 'placedOrder') {
                this.GoogleAnalyticsService.sendEvent('dc', 'cart purchase', '', 1);
                var transactionId = this.loggedInUser.customerId + Math.round((new Date()).getTime() / 1000);
                // Analytics - GTM Integration
                var eventData = this.orderSummaryEvents.orderSummaryGTMTrackingEvents.purchase;
                this.GoogleAnalyticsService.sendGTMEvent(eventData, {
                    practitionerId: this.loggedInUser.customerId,
                    ecommerce: {
                        transaction_id: transactionId,
                        affiliation: this.loggedInUser.businessName,
                        value: this.CartService.cartData.total,
                        tax: this.CartService.cartData.taxTotal,
                        shipping: this.CartService.cartData.shipVia.shipCost,
                        currency: 'USD',
                        coupon: this.CartService.cartData.couponCodes,
                        items: this.GoogleAnalyticsService.generateLineItemsTracking(this.CartService.cartData.aresLineItems)
                    }
                });
                var fullOrderData = {
                    'id': transactionId,
                    'revenue': String(this.CartService.cartData.total),
                    'shipping': String(this.CartService.cartData.shipVia.shipCost),
                    'tax': String(this.CartService.cartData.taxTotal)
                };
                ga('ecommerce:addTransaction', fullOrderData);
                try {
                    for (var _b = __values(this.CartService.cartData.aresLineItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var lineItem = _c.value;
                        var lineItemData = {
                            'id': transactionId,
                            'name': lineItem.displayName,
                            'sku': lineItem.itemId,
                            'category': lineItem.taxonomies.join(" > "),
                            'price': String(lineItem.unitPrice),
                            'quantity': String(lineItem.quantity)
                        };
                        ga('ecommerce:addItem', lineItemData);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                ga('ecommerce:send');
            }
        }
    };
    OrderSummaryListController.prototype.$onChanges = function (changes) {
        if (changes.cart) {
            this.cart = Object.assign({}, this.cart);
            if (this.cart.aresLineItems) {
                this.fillCart(this.cart);
            }
        }
    };
    OrderSummaryListController.prototype.getTotalPriceWithDiscount = function (item) {
        // note: we fear that some day discountAmount is so negative that makes the total price negative as well
        var total = item.totalPrice + item.discountAmount;
        return total < 0 ? 0 : total;
    };
    OrderSummaryListController.prototype.getItemWarnings = function (itemCodeList) {
        var itemWarningRequest = { itemCodes: itemCodeList, itemWarningId: 1 };
        return this.itemWarningsService.getItemWarnings(itemWarningRequest);
    };
    OrderSummaryListController.prototype.showItemWarnings = function (warningMessage, isMobile, $event) {
        this.$mdDialog.show({
            targeteEvent: $event,
            parent: isMobile ? angular.element(document.body) : document.getElementsByTagName('order-summary-list'),
            template: '<md-dialog>' +
                ' <div class="item-warning-message">' +
                '<div class="warning-close-icon" ng-click="closeDialog()">X</div>' +
                ' <div class="warning-icon warning-header">WARNING</div>' +
                '  <md-content class="warning-content" ng-repeat="warning in warningMessage track by $index">{{warning}}</md-content>' +
                '  <div class="md-actions">' +
                '    <md-button ng-click="closeDialog()">' +
                '      Ok' +
                '    </md-button>' +
                '  </div>' +
                '</div>' +
                '</md-dialog>',
            scope: this.$scope,
            preserveScope: true,
            clickOutsideToClose: true,
            fullscreen: false,
            locals: {
                warningMessage: warningMessage
            },
            controller: this.warningMessageCtrl
        });
    };
    OrderSummaryListController.prototype.warningMessageCtrl = function ($scope, warningMessage, $mdDialog) {
        'ngInject';
        $scope.warningMessage = warningMessage;
        $scope.closeDialog = function () {
            $mdDialog.hide();
        };
    };
    OrderSummaryListController.prototype.getOrderHoldCodes = function () {
        var _this = this;
        this.CSAService.getOrderHoldCodes()
            .then(function (data) {
            _this.orderHoldCodes = data.response;
        });
    };
    OrderSummaryListController.prototype.isOrderHoldCodeChecked = function (holdCode) {
        if (this.cart.holdCodes && this.cart.holdCodes.length) {
            return this.cart.holdCodes.find(function (item) { return item === holdCode.holdCodeKey.toString(); });
        }
    };
    OrderSummaryListController.prototype.fillCart = function (cart) {
        var self = this;
        self.quantityOfCartItems = cart.quantityOfCartItems;
        self.subTotal = cart.subTotal;
        self.shipMethod = this.CartService.getShipViaLabel(cart.shipVia.shipVia || cart.shipVia.shippingMethodId);
        self.shipTotal = cart.shipVia.shipCost;
        self.taxTotal = cart.taxTotal;
        self.totalShippingDiscount = cart.totalShippingDiscount;
        self.total = cart.total;
        self.discountTotal = cart.discountTotal;
        self.selectedPayment = cart.payment;
        self.dropshipFee = cart.dropShipFee;
        // generate id for each discount
        cart.couponCodes.forEach(function (couponElem, pos) {
            couponElem.discountName = couponElem.discountName.split('_')[0];
            couponElem['discountId'] = pos + 1;
        });
        // check each item for itemLevelDiscounts, orderLevelDiscounts, gift card coupons
        cart.aresLineItems.forEach(function (aresLineItemsElem, pos) {
            aresLineItemsElem['discounts'] = [];
            if (aresLineItemsElem.itemLevelDiscounts.length > 0) {
                aresLineItemsElem.itemLevelDiscounts.forEach(function (itemLevelDiscountItem) {
                    var discountName = itemLevelDiscountItem.discountName.split('_')[0];
                    cart.couponCodes.forEach(function (couponElem) {
                        if (discountName === couponElem.discountName) {
                            aresLineItemsElem.discounts.push(couponElem.discountId);
                        }
                    });
                });
            }
            if (aresLineItemsElem.orderLevelDiscounts.length > 0) {
                aresLineItemsElem.orderLevelDiscounts.forEach(function (orderLevelDiscountItem) {
                    var discountName = orderLevelDiscountItem.discountName.split('_')[0];
                    cart.couponCodes.forEach(function (couponElem) {
                        if (discountName === couponElem.discountName) {
                            aresLineItemsElem.discounts.push(couponElem.discountId);
                        }
                    });
                });
            }
        });
        if (cart.aresLineItems) {
            var itemCodeList_1 = [];
            cart.aresLineItems.forEach(function (item) {
                itemCodeList_1.push(item.itemId);
            });
            this.getItemWarnings(itemCodeList_1).then(function (response) {
                var warningMessageList = response.data.response;
                cart.aresLineItems.forEach(function (item) {
                    item['itemWarning'] = [];
                    warningMessageList.forEach(function (warning) {
                        if (warning.itemId === item.itemId) {
                            item['itemWarning'].push(warning.message);
                        }
                    });
                });
            });
        }
        self.orderSummary = cart.aresLineItems;
        this.commonDataService.addAttributeProductPathsForAllItems(self.orderSummary);
        if (cart.payment) {
            this.paymentType = cart.payment.paymentType;
            if (this.paymentType == 'CreditCard') {
                self.cardType = cart.payment.cardType;
            }
        }
        if ((cart.aresLineItems.length === 0 || this.thankYouPageCommingFromNowhere())
            &&
                (this.notCommingFromReviewOrder() || this.thankYouPageCommingFromNowhere())) {
            this.$state.go('cart');
        }
        self.theShippingAddress = cart.shippingAddress;
        self.aresLineItems = cart.aresLineItems;
        if (cart.shippingAddress) {
            if (cart.shippingAddress.isDropShip) {
                self.selectedAddressType = { id: 1, type: 'Patient' };
            }
            else {
                self.selectedAddressType = { id: 0, type: 'Business' };
            }
            self.isDefault = cart.shippingAddress.isDefault;
            self.makeAddressTypeEditable = true;
        }
        if (cart.aresLineItems) {
            for (var i in cart.aresLineItems) {
                if (i.isHeatSensitive) {
                    self.isHeatSensitiveItemInCart = true;
                    break;
                }
            }
        }
        if (cart.holdCodes && cart.holdCodes.length && cart.holdCodes[0] === '') {
            cart.holdCodes.splice(0, 1);
        }
        self.Util.resetApiError(self);
    };
    OrderSummaryListController.prototype.onHoldCodeClick = function (holdCode) {
        if (this.cart.holdCodes && this.cart.holdCodes.length) {
            var index = this.cart.holdCodes.findIndex(function (item) { return item === holdCode.holdCodeKey.toString(); });
            if (index > -1) {
                this.cart.holdCodes.splice(index, 1);
            }
            else {
                this.cart.holdCodes.push(holdCode.holdCodeKey.toString());
            }
        }
        else {
            this.cart.holdCodes = [];
            this.cart.holdCodes.push(holdCode.holdCodeKey.toString());
        }
        // call output event
        this.onCartChange({
            $event: {
                cart: this.cart
            }
        });
    };
    OrderSummaryListController.prototype.notCommingFromReviewOrder = function () {
        return (this.$state.current.name !== 'placedOrder'
            && this.$state.current.referrer !== 'reviewOrder');
    };
    OrderSummaryListController.prototype.thankYouPageCommingFromNowhere = function () {
        return (this.$state.current.name === 'placedOrder'
            && this.$state.current.referrer === '');
    };
    OrderSummaryListController.prototype.getOrderResultForThankyouPage = function () {
        var orderStatus = this.CartService.getOrderResult();
        if (orderStatus) {
            var orderDate = new Date();
            this.orderDate = orderDate.toLocaleDateString();
            this.customerPoNumber = orderStatus.customerPoNumber;
            this.status = orderStatus.status;
        }
    };
    OrderSummaryListController.prototype.addCustomerPoNumber = function (customerPoNumber) {
        if (customerPoNumber) {
            this.customerPoNumber = customerPoNumber;
        }
    };
    OrderSummaryListController.prototype.getExpressCheckoutStatus = function () {
        return this.CartService.getExpressCheckoutStatus();
    };
    OrderSummaryListController.prototype.clickPlaceOrder = function () {
        this.processingOrder = true;
        this.setUpOrderPayload();
    };
    OrderSummaryListController.prototype.checkCvvPattern = function () {
        if (this.cardType) {
            if (this.cardType == 2) {
                this.cvvPattern = '^[0-9]{4}$';
            }
            else {
                this.cvvPattern = '^[0-9]{3}$';
            }
        }
    };
    OrderSummaryListController.prototype.isFormValid = function (form) {
        if (!form || this.hideCVV || this.loggedInUser.isImpersonated) {
            return false;
        }
        else {
            if (form.$valid) {
                return false;
            }
            else {
                return true;
            }
        }
    };
    OrderSummaryListController.prototype.setUpOrderPayload = function () {
        var cvv;
        if (!this.hideCVV) {
            cvv = this.cvvCode;
        }
        var poNumber = this.customerPoNumber;
        if (cvv || this.paymentType !== 'CreditCard') {
            this.processOrder({
                cvv: this.cvvCode,
                customerPoNumber: this.customerPoNumber
            });
        }
        else {
            cvv = this.$rootScope.localCVV;
            this.$rootScope.localCVV = null;
            this.processOrder({
                cvv: cvv,
                customerPoNumber: this.customerPoNumber
            });
            // this.$scope.cvvForm.cvvCode.$setTouched();
            // this.$scope.cvvForm.cvvCode.$setDirty();
        }
    };
    OrderSummaryListController.prototype.ensurePaymentSet = function () {
        if (this.cart.payment)
            return this.$q.resolve();
        return this.CartService.addPayment(this.CartService.expressCheckoutContext.payment, this.CartService.expressCheckoutContext.payment.paymentType, this.cvvCode);
    };
    OrderSummaryListController.prototype.addErrorAlert = function () {
        if (angular.element(document.getElementById('pageLevelAlertWrapper'))) {
            var pageLevelAlertWrapper = angular.element(document.getElementById('pageLevelAlertWrapper'));
            pageLevelAlertWrapper.remove();
        }
        var errorHtml = "<div class=\"page-level-alert stick-top\" id=\"pageLevelAlertWrapper\" ng-if=\"$ctrl.errors.havePageErrors && $ctrl.showAlert\">\n                      <page-level-alert-messaging message=\"$ctrl.errors.pageErrors\" message-type=\"$ctrl.errors.pageErrorType\">\n                      </page-level-alert-messaging>\n                    </div>";
        angular.element(document.getElementById('orderSummaryError')).append(this.$compile(errorHtml)(this.$scope));
    };
    OrderSummaryListController.prototype.processOrder = function (params) {
        var _this = this;
        var self = this;
        var orderOrigin;
        var source;
        if (window.location.host.split('.')[1] == 'qa') {
            orderOrigin = 'AQ';
            source = 'AQ';
        }
        else if (window.location.host.split('.')[1] == 'stage') {
            orderOrigin = 'AS';
            source = 'AS';
        }
        else {
            orderOrigin = 'I';
            source = 'I';
        }
        this.commonDataService.orderSummaryList = true;
        this.ensurePaymentSet()
            .then(function () {
            // Check if customerPoNumber is empty or its length is less than or equal to 45 characters
            if (params.customerPoNumber && params.customerPoNumber.length > 45) {
                _this.addErrorAlert();
                _this.Util.handleApiError('PO Number must be less than 45 characters.', self);
                self.showAlert = true;
            }
            else {
                // Proceed with order processing if the validation passes
                return _this.CartService.processOrder({
                    orderOrigin: orderOrigin,
                    source: source,
                    customerPoNumber: params.customerPoNumber,
                    cvvCode: params.cvv,
                    holdCodes: _this.cart.holdCodes
                }, self);
            }
        })
            .then(function (res) {
            var errorMsg = null;
            if (_this.commonDataService.orderSummaryListStatus) {
                if (res.data.errors) {
                    res.data.errors.forEach(function (arr) {
                        if (arr.code === 2004) {
                            errorMsg = "Customer PO Number must not be greater than 45 characters and not contain characters <, > and &.";
                        }
                        else {
                            errorMsg = arr.message;
                        }
                    });
                    _this.processingOrder = false;
                }
                _this.commonDataService.orderSummaryListStatus = false;
                _this.addErrorAlert();
                self.Util.setPageErrors(errorMsg, '', self);
                self.showAlert = true;
            }
            else if (res.status >= 200 && res.status < 300) {
                self.orderDate = res.orderDate;
                self.CartService.setOrderResult({
                    orderDate: res.orderDate,
                    customerPoNumber: params.customerPoNumber,
                    status: res.data && res.data.response && res.data.response.orderStatus || 'Pending',
                    salesOrder: null // res.salesOrder
                });
                self.CartService.updateCart();
                //removing from session storage after place order for multicart dropdown to select the active cartid
                sessionStorage.removeItem('currentCart');
                _this.$state.go('placedOrder');
            }
            else {
                _this.addErrorAlert();
                _this.Util.handleApiError(res, self);
                self.showAlert = true;
            }
        })
            .finally(function () {
            _this.processingOrder = false;
        });
    };
    return OrderSummaryListController;
}());
export default OrderSummaryListController;
//# sourceMappingURL=order-summary-list.controller.js.map